import { h } from '@stencil/core';
import cn from 'classnames';
import { send, hmcEvent, isAnalyticsEnabled, tryParse, pesIconMirrorDirection, pesIconSizes } from '@pes-ui/utils';
import isEmpty from 'lodash/isEmpty';
import { isBrowser } from '../../../../globals/utils';
import { MarketingParams } from '../../../../globals/types';
const SQUARE_VARIANT_MAX_WIDTH = 300;
export class HmcBanner {
  constructor() {
    this.closeModal = () => {
      var _a, _b;
      (_b = (_a = this.modal) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    this.handleClick = (e) => {
      if (this.hasQuestionnaire) {
        e.preventDefault();
        this.openHmcPopup();
        const analyticsData = { pageCategoryId: this.parentCategoryId };
        if (isAnalyticsEnabled()) {
          send(hmcEvent, analyticsData);
        }
      }
    };
    this.buildClassName = (element) => {
      const block = 'hmc-banner';
      const fullClassName = element ? `${block}__${element}` : block;
      const variantClassName = `is-${this.variant}`;
      return cn(fullClassName, variantClassName);
    };
    this.renderText = () => {
      var _a, _b;
      return this.variant === 'short' ? (h("span", { class: this.buildClassName('text-content') }, h("span", { class: this.buildClassName('text'), innerHTML: (_a = this.labels) === null || _a === void 0 ? void 0 : _a.hmcStartMessage }), h("pes-icon", { class: this.buildClassName('text-arrow-icon'), size: pesIconSizes.NANO, mirror: pesIconMirrorDirection.HORIZONTAL }, "arrow2_left"))) : (h("div", { class: this.buildClassName('text') }, (_b = this.labels) === null || _b === void 0 ? void 0 : _b.hmcStartMessage));
    };
    this.getVariant = () => {
      var _a;
      if (!((_a = this.labels) === null || _a === void 0 ? void 0 : _a.hmcStartBtn)) {
        return 'short';
      }
      if (!isBrowser()) {
        return this.variant !== 'short' ? this.variant : 'extended';
      }
      const hostWidth = this.host.getBoundingClientRect().width;
      return hostWidth <= SQUARE_VARIANT_MAX_WIDTH ? 'square' : 'extended';
    };
    this.labels = undefined;
    this.categoryName = undefined;
    this.sourceId = undefined;
    this.pimId = null;
    this.parentCategoryId = null;
    this.categoryProductConfiguratorUrl = undefined;
    this.isExternalProductConfiguratorUrl = undefined;
    this.hasQuestionnaire = false;
    this.questionnaireUrl = undefined;
    this.rangeTooltipUrl = undefined;
    this.selectorConfigUrl = undefined;
    this.variant = 'short';
    this.hideHMCBanner = false;
    this.hmcBanner = undefined;
    this.hmcHost = undefined;
    this.token = undefined;
    this.pageSource = undefined;
    this.channel = undefined;
    this._labels = undefined;
    this._categoryName = undefined;
    this._pimId = undefined;
    this._sourceId = undefined;
    this._parentCategoryId = undefined;
    this._categoryProductConfiguratorUrl = undefined;
    this._isExternalProductConfiguratorUrl = undefined;
    this._hasQuestionnaire = undefined;
    this._questionnaireUrl = undefined;
    this._rangeTooltipUrl = undefined;
    this._selectorConfigUrl = undefined;
    this._hideHMCBanner = undefined;
    this._hmcBanner = undefined;
    this._variant = undefined;
    this._hmcHost = undefined;
    this._token = undefined;
    this._pageSource = undefined;
    this._channel = undefined;
    this.host.dir = document.documentElement.dir || 'auto';
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    this.labels = (_a = tryParse(this._labels)) !== null && _a !== void 0 ? _a : this.labels;
    this.categoryName = (_b = tryParse(this._categoryName)) !== null && _b !== void 0 ? _b : this.categoryName;
    const pimId = (_c = tryParse(this._pimId)) !== null && _c !== void 0 ? _c : this.pimId;
    const sourceId = (_d = tryParse(this._sourceId)) !== null && _d !== void 0 ? _d : this.sourceId;
    this.sourceId = pimId === null ? sourceId : pimId;
    this.categoryProductConfiguratorUrl = (_e = tryParse(this._categoryProductConfiguratorUrl)) !== null && _e !== void 0 ? _e : this.categoryProductConfiguratorUrl;
    this.isExternalProductConfiguratorUrl = (_f = tryParse(this._isExternalProductConfiguratorUrl)) !== null && _f !== void 0 ? _f : this.isExternalProductConfiguratorUrl;
    this.hasQuestionnaire = (_g = tryParse(this._hasQuestionnaire)) !== null && _g !== void 0 ? _g : this.hasQuestionnaire;
    this.questionnaireUrl = (_h = tryParse(this._questionnaireUrl)) !== null && _h !== void 0 ? _h : this.questionnaireUrl;
    this.rangeTooltipUrl = (_j = tryParse(this._rangeTooltipUrl)) !== null && _j !== void 0 ? _j : this.rangeTooltipUrl;
    this.selectorConfigUrl = (_k = tryParse(this._selectorConfigUrl)) !== null && _k !== void 0 ? _k : this.selectorConfigUrl;
    this.variant = (_l = tryParse(this._variant)) !== null && _l !== void 0 ? _l : this.variant;
    this.parentCategoryId = (_m = tryParse(this._parentCategoryId)) !== null && _m !== void 0 ? _m : this.parentCategoryId;
    this.hideHMCBanner = (_o = tryParse(this._hideHMCBanner)) !== null && _o !== void 0 ? _o : this.hideHMCBanner;
    this.hmcBanner = (_p = tryParse(this._hmcBanner)) !== null && _p !== void 0 ? _p : this.hmcBanner;
    this.hmcHost = (_q = tryParse(this._hmcHost)) !== null && _q !== void 0 ? _q : this.hmcHost;
    this.channel = (_r = tryParse(this._channel)) !== null && _r !== void 0 ? _r : this.channel;
    this.pageSource = (_s = tryParse(this._pageSource)) !== null && _s !== void 0 ? _s : this.pageSource;
    this.token = (_t = tryParse(this._token)) !== null && _t !== void 0 ? _t : this.token;
    this.handleMarketingParameters();
  }
  openHmcPopup() {
    this.modal = document.createElement('pes-hmc-modal-container');
    this.modal.host = this.hmcHost;
    this.modal.token = this.token;
    this.modal.channel = this.channel;
    this.modal.pageSource = this.pageSource;
    this.modal.closeModal = this.closeModal;
    document.body.appendChild(this.modal);
  }
  getTargetForUrl() {
    return this.isExternalProductConfiguratorUrl ? '_blank' : '_self';
  }
  componentDidLoad() {
    this.variant = this.getVariant();
  }
  isHMCEnabled() {
    return !this.hideHMCBanner && !isEmpty(this.labels);
  }
  handleMarketingParameters() {
    const hmcEnabled = this.isHMCEnabled();
    if (!hmcEnabled || !isBrowser())
      return;
    const urlParams = new URLSearchParams(window.location.search);
    const hasUTMParams = urlParams.has(MarketingParams.HMC_ACTIVE);
    if (!hasUTMParams)
      return;
    this.openHmcPopup();
  }
  render() {
    var _a, _b, _c, _d;
    const heading = this.variant !== 'short' && this.categoryName
      ? (_a = this.labels) === null || _a === void 0 ? void 0 : _a.hmcHeader.replace('#CategoryName#', this.categoryName)
      : (_b = this.labels) === null || _b === void 0 ? void 0 : _b.hmcHeader;
    const urlProps = !this.hasQuestionnaire && this.categoryProductConfiguratorUrl
      ? {
        url: this.categoryProductConfiguratorUrl,
        target: this.getTargetForUrl(),
      }
      : {};
    if (!this.labels)
      return null;
    return (h("div", { class: cn({
        'subcategories__banner-container--prerender': this.isHMCEnabled(),
      }) }, this.isHMCEnabled() && isBrowser() ? (h("pes-banner", Object.assign({}, urlProps, { icon: "action_search_stroke", onClick: this.handleClick }), h("div", { class: this.buildClassName() }, h("div", { class: this.buildClassName('text-block') }, h("h2", { class: this.buildClassName('heading'), innerHTML: heading }), this.renderText()), ((_c = this.labels) === null || _c === void 0 ? void 0 : _c.hmcStartBtn) && (h("button", { type: "button", class: this.buildClassName('button') }, (_d = this.labels) === null || _d === void 0 ? void 0 : _d.hmcStartBtn))))) : null));
  }
  static get is() { return "pes-hmc-banner"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["hmc-banner.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["hmc-banner.css"]
    };
  }
  static get properties() {
    return {
      "labels": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "THMCBannerLabels",
          "resolved": "{ hmcStartBtn?: string; hmcHeader?: string; hmcStartMessage?: string; }",
          "references": {
            "THMCBannerLabels": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "object with labels"
        }
      },
      "categoryName": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "Circuit Breakers"
            }],
          "text": "Name of the category."
        },
        "attribute": "category-name",
        "reflect": false
      },
      "sourceId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Id of the category."
        },
        "attribute": "source-id",
        "reflect": false
      },
      "pimId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "pimId for category."
        },
        "attribute": "pim-id",
        "reflect": false,
        "defaultValue": "null"
      },
      "parentCategoryId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Parent id of the category."
        },
        "attribute": "parent-category-id",
        "reflect": false,
        "defaultValue": "null"
      },
      "categoryProductConfiguratorUrl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "http://some.domain/some/path#some-hash?some=query"
            }],
          "text": "URL to category product configurator."
        },
        "attribute": "category-product-configurator-url",
        "reflect": false
      },
      "isExternalProductConfiguratorUrl": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the categoryProductConfiguratorUrl will be opened in a new tab"
        },
        "attribute": "is-external-product-configurator-url",
        "reflect": false
      },
      "hasQuestionnaire": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [{
              "name": "example",
              "text": "true"
            }],
          "text": "Has Help Me Choose questionnaire.\n\nIf `true`, Help Me Choose widget will be opened."
        },
        "attribute": "has-questionnaire",
        "reflect": false,
        "defaultValue": "false"
      },
      "questionnaireUrl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Url for requesting questionnaire."
        },
        "attribute": "questionnaire-url",
        "reflect": false
      },
      "rangeTooltipUrl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Url for requesting range tooltip info."
        },
        "attribute": "range-tooltip-url",
        "reflect": false
      },
      "selectorConfigUrl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Url for requesting product selector config."
        },
        "attribute": "selector-config-url",
        "reflect": false
      },
      "variant": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "TBannerVariant",
          "resolved": "\"extended\" | \"short\" | \"square\"",
          "references": {
            "TBannerVariant": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false,
        "defaultValue": "'short'"
      },
      "hideHMCBanner": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "hide Help Me Choose block"
        },
        "attribute": "hide-h-m-c-banner",
        "reflect": false,
        "defaultValue": "false"
      },
      "hmcBanner": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "THMCBanner",
          "resolved": "{ sourceId?: string; parentCategoryId?: string; categoryName?: string; labels?: THMCBannerLabels; hasQuestionnaire?: boolean; categoryProductConfiguratorUrl?: string; questionnaireUrl?: string; rangeTooltipUrl?: string; selectorConfigUrl?: string; isExternalProductConfiguratorUrl?: boolean; pimId?: string; host?: string; token?: string; channel?: string; pageSource?: string; }",
          "references": {
            "THMCBanner": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "data for Help Me Choose\npass null to disable it"
        }
      },
      "hmcHost": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines whether the component is integrated to PBS."
        },
        "attribute": "hmc-host",
        "reflect": false
      },
      "token": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "token",
        "reflect": false
      },
      "pageSource": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "page-source",
        "reflect": false
      },
      "channel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "channel",
        "reflect": false
      },
      "_labels": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-labels",
        "reflect": false
      },
      "_categoryName": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-category-name",
        "reflect": false
      },
      "_pimId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-pim-id",
        "reflect": false
      },
      "_sourceId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-source-id",
        "reflect": false
      },
      "_parentCategoryId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-parent-category-id",
        "reflect": false
      },
      "_categoryProductConfiguratorUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-category-product-configurator-url",
        "reflect": false
      },
      "_isExternalProductConfiguratorUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-is-external-product-configurator-url",
        "reflect": false
      },
      "_hasQuestionnaire": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-has-questionnaire",
        "reflect": false
      },
      "_questionnaireUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-questionnaire-url",
        "reflect": false
      },
      "_rangeTooltipUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-tooltip-url",
        "reflect": false
      },
      "_selectorConfigUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-selector-config-url",
        "reflect": false
      },
      "_hideHMCBanner": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-hide-hmc-banner",
        "reflect": false
      },
      "_hmcBanner": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-hmc-banner",
        "reflect": false
      },
      "_variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-variant",
        "reflect": false
      },
      "_hmcHost": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-host",
        "reflect": false
      },
      "_token": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-token",
        "reflect": false
      },
      "_pageSource": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-page-source",
        "reflect": false
      },
      "_channel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-channel",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "host"; }
}
